import { useQuery } from "@tanstack/react-query";
import { getUsPhoneNumberPricing } from "../actions/get-us-phone-number-pricing.actions";
import { US_PHONE_NUMBER_PRICING_QUERY_KEYS } from "../queries/us-phone-number.queries";

interface UsePricingUsPhoneNumberParams {
    phoneNumber?: string;
    enabled?: boolean;
}

export const usePricingUsPhoneNumber = ({
    phoneNumber,
    enabled = true,
}: UsePricingUsPhoneNumberParams) => {
    return useQuery({
        queryKey: US_PHONE_NUMBER_PRICING_QUERY_KEYS.byPhoneNumber(
            phoneNumber ?? "",
        ),
        queryFn: () => getUsPhoneNumberPricing(phoneNumber!),
        enabled: enabled && !!phoneNumber,
        staleTime: 1000 * 60 * 30,
        retry: 1,
    });
};